import Loader from '@/components/base/Loader';
import SearchBox from '@/components/composite/SearchBox';

export const DefaultSearchBox = ({ children, noChoicesMessage = '', ...restProps }) => {
    return (
        <SearchBox {...restProps}>
            <SearchBox.ErrorInForm />
            <SearchBox.ErrorInList />
            <SearchBox.ContentWrapper>
                <SearchBox.Input />
                <SearchBox.ListsItems noChoicesMessage={noChoicesMessage}>
                    {children}
                </SearchBox.ListsItems>
            </SearchBox.ContentWrapper>
        </SearchBox>
    );
};

export const DefaultSearchBoxPlaceholder = () => (
    <SearchBox>
        <SearchBox.ErrorInForm />
        <SearchBox.ErrorInList />
        <SearchBox.ContentWrapper>
            <SearchBox.Input disabled />
            <SearchBox.ListsItems>
                <Loader className="h-4 w-4 text-icoBlue" />
            </SearchBox.ListsItems>
        </SearchBox.ContentWrapper>
    </SearchBox>
);
